import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25f445e0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f445e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f445e0')) {
      api.createRecord('25f445e0', component.options)
    } else {
      api.reload('25f445e0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=25f445e0&scoped=true", function () {
      api.rerender('25f445e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/account/components/viewForm/index.vue"
export default component.exports